"use client";

import { useState } from "react";
import { Input } from "../ui/input";
import { Button } from "../ui/button";
import { Eye, EyeOff } from "lucide-react";

interface SecretValueInputProps {
  id: string;
  /** The NEW value being entered (controlled). Never seeded from a stored secret — write-only. */
  value: string;
  onChange: (v: string) => void;
  placeholder?: string;
  disabled?: boolean;
}

// Write-only masked value input for secrets. The field is NEVER seeded from a stored secret (the API
// returns the value masked/null) — entering a value replaces it. The show/hide toggle only reveals what
// the admin is currently typing; it can never display the stored secret. Shared across admin apps
// (conduit settings, passport OAuth clients).
export function SecretValueInput({ id, value, onChange, placeholder, disabled }: SecretValueInputProps) {
  const [show, setShow] = useState(false);
  return (
    <div className="flex gap-2">
      <Input
        id={id}
        type={show ? "text" : "password"}
        value={value}
        placeholder={placeholder}
        disabled={disabled}
        autoComplete="off"
        onChange={(e) => onChange(e.target.value)}
      />
      <Button
        type="button"
        variant="outline"
        size="icon"
        disabled={disabled}
        aria-label={show ? "Hide value" : "Show value"}
        onClick={() => setShow((s) => !s)}
      >
        {show ? <EyeOff className="size-4" /> : <Eye className="size-4" />}
      </Button>
    </div>
  );
}
